import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "radio";
var classes = {
    RADIO: 'tyl-radio',
    RADIO_DENSE: 'tyl-radio--dense',
    DISABLED: 'tyl-radio--disabled',
    CHECKED: 'tyl-radio--checked',
    FOCUSED: 'tyl-radio--focused',
    ENABLED: 'tyl-radio--enabled',
};
var selectors = {
    RADIO: '.tyl-radio',
    RADIO_INPUT: 'input[type="radio"]',
    LABEL: 'label'
};
var attributes = {
    DENSE: 'dense',
    ROLE: 'role',
    RADIOGROUP_ROLE: 'radiogroup',
    SLOT: 'slot',
};
var inputProperties = ['checked', 'disabled'];
export var RADIO_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    inputProperties: inputProperties
};
